import { render, staticRenderFns } from "./TouchPointInfo.vue?vue&type=template&id=8736c7de&scoped=true&"
import script from "./TouchPointInfo.vue?vue&type=script&lang=js&"
export * from "./TouchPointInfo.vue?vue&type=script&lang=js&"
import style0 from "./TouchPointInfo.vue?vue&type=style&index=0&id=8736c7de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8736c7de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8736c7de')) {
      api.createRecord('8736c7de', component.options)
    } else {
      api.reload('8736c7de', component.options)
    }
    module.hot.accept("./TouchPointInfo.vue?vue&type=template&id=8736c7de&scoped=true&", function () {
      api.rerender('8736c7de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Charts/SankeyV2/TouchpointInfo/TouchPointInfo.vue"
export default component.exports